var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-header',{attrs:{"height":"50px"}},[(_vm.$route.path !== '/')?_c('crm-header'):_vm._e()],1),(_vm.$route.path !== '/')?_c('crm-container',[_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }